import React from "react";

import Router from "./routes";
import { keycloak, isKeycloakEnabled } from "./keycloak";
import { SpinnerWrapper } from "@components/Common/SpinnerWrapper";
import { FidelityNavigationGuardProvider } from "@pages/SettingGeneral/Fidelity/FidelityNavigationGuardContext";

const AuthenticatedApp: React.FC = () => {
    const { useKeycloak } = require("@react-keycloak/web");
    const { keycloak, initialized } = useKeycloak();

    if (!initialized || !keycloak.authenticated) {
        return <SpinnerWrapper />;
    }

    return <Router />;
};

export default function App(): any {
    const tree =
        isKeycloakEnabled && keycloak ? <AuthenticatedApp /> : <Router />;
    return (
        <FidelityNavigationGuardProvider>{tree}</FidelityNavigationGuardProvider>
    );
}
